import { TaskingMapLayerName } from "./types";

export function layerID(name: TaskingMapLayerName, key: string[]) {
  return `${name}/${key.join("/")}`;
}

export function layerNameFromID(id: string) {
  return id.split("/")[0] as TaskingMapLayerName;
}
